import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  imageSrc = '/assets/img/contact-img.png';
  constructor(  
    private titleService: Title,  
    private metaTagService: Meta  
  ) { }  
    

  ngOnInit() {  
    this.titleService.setTitle("Contact Avitrons | Let's Discuss Your Digital Vision for the USA Market");  
    
    this.metaTagService.addTags([  
      { name: 'description', content: 'Reach out to Avitrons for personalized consultations and solutions. Contact us to discuss your digital vision for the USA market, and lets collaborate to achieve your business goals.'},  
      { name: 'robots', content: 'index, follow' },  
      { charset: 'UTF-8' } , 
    ]);  
        
  }  
}  
